import React, { useState, useEffect } from 'react';
import { Card } from '@/components/ui/card';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const TermsOfService = () => {
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTerms();
  }, []);

  const fetchTerms = async () => {
    try {
      const response = await axios.get(`${API_URL}/legal/terms-of-service`);
      setTerms(response.data);
    } catch (error) {
      console.error('Failed to load terms');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 via-accent-50 to-secondary-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-accent-50 to-secondary-50 py-12 px-6" data-testid="terms-page">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-primary hover:text-primary-700 font-semibold mb-6">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <Card className="p-8 md:p-12 rounded-3xl border border-white/20 shadow-xl bg-white/70 backdrop-blur-md">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
                <FileText className="w-9 h-9 text-white" />
              </div>
              <div>
                <h1 className="text-4xl font-heading font-black text-gray-900">{terms?.title}</h1>
                <p className="text-sm text-gray-600 mt-1">
                  Effective Date: {terms?.effective_date} | Last Updated: {terms?.last_updated}
                </p>
              </div>
            </div>

            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 mb-8 text-lg leading-relaxed">{terms?.content?.introduction}</p>

              {terms?.content?.sections?.map((section, idx) => (
                <div key={idx} className="mb-8">
                  <h2 className="text-2xl font-heading font-bold text-gray-900 mb-4">{section.title}</h2>
                  {section.content.map((item, itemIdx) => (
                    <div key={itemIdx} className="mb-4">
                      {item.subtitle && (
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">{item.subtitle}</h3>
                      )}
                      <p className="text-gray-700 leading-relaxed whitespace-pre-line">{item.text}</p>
                    </div>
                  ))}
                </div>
              ))}
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-600">
                By using Socyy, you agree to be bound by these Terms of Service.
              </p>
            </div>
          </Card>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsOfService;